/** 搜索列表过滤器 **/
const listFilter = {
  namespaced: true,
  state: {
    sortType: 2,
    summaryType: 0,
  },
  getters: {
    sortType: (state) => state.sortType,
  },
  mutations: {
    updateSortType(state, sortType) {
      state.sortType = sortType;
    },
    updateSummaryType(state, summaryType) {
      state.summaryType = summaryType;
    },
  },
  actions: {},
};
export default listFilter;
